import React from 'react';
import { useNavigate } from 'react-router-dom';

import routes from 'app/routes';
import Modal from 'components/new_ui/Modal/Modal';
import { useContext } from 'components/Affiliates/Prospects/Context';

import Form from '../Form';

export default function Index() {
  const { dispatch, actions } = useContext();
  const navigate = useNavigate();

  const onSave = (values, { setSubmitting, setErrors }) => {
    actions.create(dispatch, values, () => {
      setSubmitting(false);
      navigate(
        routes.affiliates.prospects.index,
      );
    }, (errors) => {
      const newErrors = {};
      errors.forEach((item) => {
        newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
      });
      setErrors(newErrors);
      setSubmitting(false);
    });
  };

  return (
    <Modal show>

      <Form
        onSave={onSave}
        initialValues={{
          company: '',
          website: '',
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          jobTitle: '',
        }}
      />

    </Modal>
  );
}
